import React, { useState } from 'react';
import { Box, InputAdornment, List, ListItem, ListItemButton, OutlinedInput, Paper, Typography, useTheme } from '@mui/material';
import { IconSearch } from '@tabler/icons';
import api from '../../services/api';

// Widget de busca "digite, veja a lista de resultado, escolha um" -
// reaproveitado por Responsável/Cliente/Organização tanto em
// TicketFormDrawer.js quanto em TicketDetailDrawer.js (antes cada um
// repetia a mesma combinação OutlinedInput+Paper/List quase idêntica 3x).
// Mesmo padrão visual que DadosDealDrawer.js já usa pros mesmos campos.
const EntityPickerInline = ({
    label,
    placeholder,
    searchUrl, // (term) => string (endpoint relativo, ex: `v1/apps/${appId}/users/?search=${term}`)
    extractResults, // (response.data) => array
    getOptionLabel, // (item) => string
    value, // item selecionado atualmente (objeto) ou null
    onSelect,
    onClear,
    clearLabel = 'Limpar',
    minChars = 2
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const [term, setTerm] = useState('');
    const [results, setResults] = useState([]);
    const [showResults, setShowResults] = useState(false);

    const handleChange = async (e) => {
        const val = e.target.value;
        setTerm(val);
        if (val.length < minChars) {
            setShowResults(false);
            return;
        }
        try {
            const response = await api.get(searchUrl(val));
            setResults(extractResults(response.data) || []);
            setShowResults(true);
        } catch (error) {
            console.error(`Erro ao buscar ${label}`, error);
        }
    };

    return (
        <Box sx={{ p: 1, borderRadius: 2, background: isDark ? '#1f2c33' : '#f7f8fa' }}>
            <Typography fontWeight={600} variant="body2">
                {label}
            </Typography>
            <OutlinedInput
                fullWidth
                size="small"
                placeholder={placeholder}
                value={value ? getOptionLabel(value) : term}
                onChange={handleChange}
                sx={{ mt: 1 }}
                startAdornment={
                    <InputAdornment position="start">
                        <IconSearch size="1.1rem" color="#666" />
                    </InputAdornment>
                }
            />
            {showResults && (
                <Paper elevation={3} sx={{ mt: 0.5 }}>
                    <List dense>
                        {results.length === 0 && <ListItem>Nenhum resultado encontrado</ListItem>}
                        {results.map((item) => (
                            <ListItem disablePadding key={item.id}>
                                <ListItemButton
                                    onClick={() => {
                                        onSelect(item);
                                        setTerm('');
                                        setShowResults(false);
                                    }}
                                >
                                    {getOptionLabel(item)}
                                </ListItemButton>
                            </ListItem>
                        ))}
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    onClear();
                                    setTerm('');
                                    setShowResults(false);
                                }}
                            >
                                {clearLabel}
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Paper>
            )}
        </Box>
    );
};

export default EntityPickerInline;
